import { Field, TextInput, TextOutput } from 'Components/Core';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { ListDropdown } from 'Components/List';
import { useSelector } from 'react-redux';
import { IReportConfigurationGroup } from './types';

const ReportConfigurationGroupAdmin = () => {
  const data: IReportConfigurationGroup = useSelector((state: any) => state.admin.syncModel);
  return (
    <>
      <PageSection heading="Details">
        <ListFieldSection wide>
          <Field label="Name" input={data.SystemDefined ? <TextOutput /> : <TextInput />} name="syncModel.Name" />
          <Field
            label="Description"
            input={data.SystemDefined ? <TextOutput /> : <TextInput />}
            name="syncModel.Description"
          />
          <Field
            label="Laboratories"
            input={<ListDropdown />}
            endpoint="list.laboratories.allLocations"
            isMulti={true}
            placeholder="Select Laboratories/Regions"
            name="syncModel.Laboratories"
            disabled={data.SystemDefined}
          />
        </ListFieldSection>
      </PageSection>
    </>
  );
};

export default ReportConfigurationGroupAdmin;
export { ReportConfigurationGroupAdmin };
